/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { toNumber } from "../../components/Common";

import * as BSL_Common from "../../components/BSL_CommonControls";
import BSL_TextInput from "../../components/BSL_TextInput";
import * as APP from "../../redux_store/appState";
import * as CONFIG from "../../redux_store/configState";
import { updateAreaSpecificationShape } from "../../redux_store/jobState";
import { SITE_PARAMETER_SECTIONS, BASIC_SPECS_SECTIONS } from "../../redux_store/jobState_Schemas";
import SpecShapeCutoutTool from "./SpecShapeCutoutTool";

import SegmentedButtonGroup from "../../components/SegmentedButtonGroup";
import BSL_Slider from "../../components/BSL_Slider";
import BSL_Button from "../../components/BSL_Button";
import { Drawer } from "@material-ui/core";
import BSL_CheckBox from "../../components/BSL_CheckBox";
import WarningIcon from "@material-ui/icons/Warning";

const useStyles = makeStyles({
    root: {
        // background: "#D9E1E5",
        // maxWidth: '400px',
        // minWidth: '30px',
        padding: "0px 8px 8px 8px",
    },
    cutoutSummary: {
        color: "#3a3a3a",
    },
    paper_root: {
        background: "#090909ad",
    },
});

export default function ShapeDesignTools(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    // const [password, setPassword] = React.useState("");
    const { areaIndex } = props;
    const job = useSelector((state) => state.job);
    const area_design_specs = job?.AreaSpecifications?.[areaIndex];
    const ShapeParameters = area_design_specs?.SHAPE;
    const areaLast_design_specs = job?.AreaSpecifications?.[areaIndex - 1];
    const areaNext_design_specs = job?.AreaSpecifications?.[areaIndex + 1];
    let min_side_overhang = area_design_specs?.[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_side_overhang;

    if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) min_side_overhang = 0;

    const config = useSelector((state) => state.config);

    const design_option = config?.design_options?.[area_design_specs.SHAPE.DesignType];

    let design_subtype_value = ShapeParameters.DesignSubType;
    if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT)
        design_subtype_value =
            ShapeParameters.DesignSubType === "Type 4"
                ? "Type 4/Front"
                : ShapeParameters.DesignSubType + "/" + area_design_specs.SHAPE.SheetDirection;

    const [open_cutouts, setOpenCutouts] = React.useState(false);

    // const [openSteelFrameDialog, setOpenSteelFrameDialog] = React.useState(false);
    // const [openFlyoverDialog, setopenFlyoverDialog] = React.useState(false);

    const updateShapeDataValue = (dataField, value = null) => {
        let error = dispatch(updateAreaSpecificationShape(areaIndex, null, dataField, value));
        if (error && error.error) {
            dispatch(APP.showDialogData(error));
        }
    };
    const updateShapeData =
        (dataField) =>
        (event, value = null) => {
            if (value === null) value = event?.target?.value ? event?.target?.value : event;

            return updateShapeDataValue(dataField, value);
        };

    let design_types = [];
    let design_type_helper_text = "";
    if (config?.design_types) {
        for (let type of config?.design_types) {
            if (window.LYSAGHT)
                design_types.push({
                    Key: type,
                    Display: type === CONFIG.DESIGN_TYPES.GABLE_PORTAL ? "Gable Roof" : type,
                });
            else
                design_types.push({
                    Key: type,
                    Display: type === CONFIG.DESIGN_TYPES.GABLE_PORTAL ? "Gable Roof" : type,
                });
        }
        if (!config.design_types.includes(ShapeParameters?.DesignType)) {
            design_types.push({
                Key: ShapeParameters?.DesignType,
                Display: (
                    <>
                        <WarningIcon
                            style={{
                                width: "17px",
                                height: "13px",
                                color: "#e29d35",
                            }}
                        />
                        {ShapeParameters?.DesignType}
                    </>
                ),
                tooltip: "No longer available",
            });
            design_type_helper_text = (
                <div style={{ textWrap: "pretty" }}>
                    {ShapeParameters?.DesignType} is no longer available as an option. If you change this, you cannot
                    reselect it.
                </div>
            );
        }
    } else {
        design_types = [
            { Key: "Flat Roof", Display: "Flat Roof" },
            { Key: "Pitched Roof", Display: "Pitched Gable" },
            { Key: "Gable Hip Roof", Display: "Portal Gable" },
        ];
    }

    let subtypes_options = [
        { Key: "Type 4/Front", Display: "Projection" },
        { Key: "Type 3/Left", Display: "Parallel Left" },
        { Key: "Type 3/Right", Display: "Parallel Right" },
    ];
    if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL)
        subtypes_options = [
            { Key: "Projection", Display: "Projection" },
            { Key: "Parallel", Display: "Parallel" },
        ];
    if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED)
        subtypes_options = [{ Key: "Type 4", Display: "Projection" }];

    let gableEnd1 = "Left Gable End Type";
    let gableEnd2 = "Right Gable End Type";

    if (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL) {
        if (area_design_specs.SHAPE.DesignSubType === CONFIG.DESIGN_SUBTYPES.PROJECTION) {
            gableEnd1 = "Back Gable End Type";
            gableEnd2 = "Front Gable End Type";
        }
    }

    let min_pitch = toNumber(area_design_specs[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofSheetData?.min_pitch);

    let min_design_pitch_allowed = design_option?.pitch_range?.min ? design_option?.pitch_range?.min : 1;
    if (typeof min_design_pitch_allowed === "string" && min_design_pitch_allowed.includes("min_pitch"))
        min_design_pitch_allowed = min_pitch;

    let max_design_pitch_allowed = design_option?.pitch_range?.max ? design_option?.pitch_range?.max : 30;

    let gable_end_options = [
        { Key: "Gable", Display: "Gable" },
        { Key: "Hip/45", Display: "Hip (45°)" },
        // { Key: "Hip/60", Display: "Hip (60°)" },
        { Key: "Dutch Gable", Display: "Dutch" },
        // { Key: "Gazebo", Display: "Gazebo" },
    ];
    if (window.LYSAGHT) {
        gable_end_options = [
            { Key: "Gable", Display: "Gable" },
            { Key: "Hip/45", Display: "Hip" },
            { Key: "Dutch Gable", Display: "Dutch" },
        ];
        if (area_design_specs.SHAPE.RoofPitch === 15) {
            gable_end_options = [
                { Key: "Gable", Display: "Gable" },
                {
                    Key: "Hip/45",
                    Display: "Hip",
                    disabled: true,
                    disabledTooltip: "Not available with 15 degree roof pitch",
                },
                {
                    Key: "Dutch Gable",
                    Display: "Dutch",
                    disabled: true,
                    disabledTooltip: "Not available with 15 degree pitch",
                },
            ];
        }
    }

    let max_depth_override = null;
    let max_depth_override_helper_text = null;
    let max_length_override = null;
    let max_length_override_helper_text = null;
    let roofsheet_data = area_design_specs[BASIC_SPECS_SECTIONS.ROOF_SHEETING];

    let last_area_data = areaLast_design_specs;
    let next_area_data = areaNext_design_specs;
    let this_area_data = area_design_specs;
    let pitch_matched_for_flat_hip = this_area_data[BASIC_SPECS_SECTIONS.SHAPE].RoofPitchMatched;

    let rotated = area_design_specs.META.LengthDepthRotated;

    return (
        <div className={classes.root} key={areaIndex}>
            <BSL_Common.SectionHeader style={{ paddingTop: "0px" }}>Design Types</BSL_Common.SectionHeader>
            <BSL_Common.SectionContainer>
                {/* <BSL_Common.SectionRow> */}
                <SegmentedButtonGroup
                    tight
                    value={ShapeParameters?.DesignType}
                    items={design_types}
                    onChange={updateShapeData("DesignType")}
                    helperText={design_type_helper_text}
                />
                {/* </BSL_Common.SectionRow> */}
                <SegmentedButtonGroup
                    tight
                    value={design_subtype_value}
                    items={subtypes_options}
                    onChange={updateShapeData("DesignSubType")}
                />

                {window.LYSAGHT && area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && (
                    <BSL_Common.SectionRow>
                        <SegmentedButtonGroup
                            label={gableEnd1}
                            tight
                            value={
                                ShapeParameters?.RoofType1 === "Hip"
                                    ? "Hip/" + ShapeParameters?.HipAngle1
                                    : ShapeParameters?.RoofType1
                            }
                            items={gable_end_options}
                            disabled={
                                areaLast_design_specs &&
                                ["Hip", "Gable"].includes(areaLast_design_specs?.SHAPE?.AREAJOIN?.JoinType)
                            }
                            onChange={updateShapeData("RoofType1")}
                        />
                        <SegmentedButtonGroup
                            label={gableEnd2}
                            tight
                            value={
                                ShapeParameters?.RoofType2 === "Hip"
                                    ? "Hip/" + ShapeParameters?.HipAngle2
                                    : ShapeParameters?.RoofType2
                            }
                            items={gable_end_options}
                            disabled={
                                areaNext_design_specs &&
                                ["Hip", "Gable"].includes(area_design_specs?.SHAPE?.AREAJOIN?.JoinType)
                            }
                            onChange={updateShapeData("RoofType2")}
                        />
                    </BSL_Common.SectionRow>
                )}
                {
                    !window.LYSAGHT && area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL && (
                        // <BSL_Common.SectionRow>
                        <>
                            <SegmentedButtonGroup
                                label={gableEnd1}
                                tight
                                value={
                                    ShapeParameters?.RoofType1 === "Hip"
                                        ? "Hip/" + ShapeParameters?.HipAngle1
                                        : ShapeParameters?.RoofType1
                                }
                                items={gable_end_options}
                                disabled={
                                    areaLast_design_specs &&
                                    ["Hip", "Gable"].includes(areaLast_design_specs?.SHAPE?.AREAJOIN?.JoinType)
                                }
                                onChange={updateShapeData("RoofType1")}
                            />
                            <SegmentedButtonGroup
                                label={gableEnd2}
                                tight
                                value={
                                    ShapeParameters?.RoofType2 === "Hip"
                                        ? "Hip/" + ShapeParameters?.HipAngle2
                                        : ShapeParameters?.RoofType2
                                }
                                items={gable_end_options}
                                disabled={
                                    areaNext_design_specs &&
                                    ["Hip", "Gable"].includes(area_design_specs?.SHAPE?.AREAJOIN?.JoinType)
                                }
                                onChange={updateShapeData("RoofType2")}
                            />
                        </>
                    )
                    // </BSL_Common.SectionRow>
                }
            </BSL_Common.SectionContainer>

            <BSL_Common.SectionHeader>Frame Dimensions</BSL_Common.SectionHeader>
            <BSL_Common.SectionContainer>
                <BSL_Common.SectionRow>
                    <BSL_TextInput
                        label={"Frame Length"}
                        value={ShapeParameters?.Length}
                        tight
                        min={
                            rotated && design_option?.depth_range?.min !== undefined
                                ? design_option?.depth_range?.min
                                : design_option?.length_range?.min
                                ? design_option?.length_range?.min
                                : 500
                        }
                        max={
                            max_length_override
                                ? max_length_override
                                : rotated && design_option?.depth_range?.max
                                ? design_option?.depth_range?.max
                                : design_option?.length_range?.max
                                ? design_option?.length_range?.max
                                : 20000
                        }
                        endAdornment="mm"
                        onBlur={updateShapeData("Length")}
                        helperText={max_length_override_helper_text}
                    />
                    <BSL_TextInput
                        label={
                            area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL
                                ? "Frame Span"
                                : "Frame Width"
                        }
                        value={ShapeParameters?.Depth}
                        tight
                        min={
                            rotated && design_option?.length_range?.min !== undefined
                                ? design_option?.length_range?.min
                                : design_option?.depth_range?.min
                                ? design_option?.depth_range?.min
                                : 300
                        }
                        max={
                            max_depth_override
                                ? max_depth_override
                                : rotated && design_option?.length_range?.max
                                ? design_option?.length_range?.max
                                : design_option?.depth_range?.max
                                ? design_option?.depth_range?.max
                                : 12000
                        }
                        endAdornment="mm"
                        onBlur={updateShapeData("Depth")}
                        helperText={max_depth_override_helper_text}
                    />
                    <BSL_TextInput
                        label="Pitching Height"
                        value={ShapeParameters?.Height}
                        tight
                        min={design_option?.height_range?.min ? design_option?.height_range?.min : 2100}
                        max={design_option?.height_range?.max ? design_option?.height_range?.max : 5000}
                        endAdornment="mm"
                        onBlur={updateShapeData("Height")}
                        helperText={
                            area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ? (
                                <>
                                    FFL to <span style={{ fontWeight: 600 }}>Edge Beam</span> Underside
                                </>
                            ) : (
                                <>
                                    FFL to <span style={{ fontWeight: 600 }}>Sheet</span> Underside
                                </>
                            )
                        }
                    />
                </BSL_Common.SectionRow>
                <BSL_Common.SectionRow>
                    {pitch_matched_for_flat_hip && (
                        <div
                            style={{
                                position: "fixed",
                                paddingLeft: "62px",
                                paddingTop: "33px",
                                fontSize: "12px",
                                width: "80%",
                                textAlign: "left",
                                textWrap: "wrap",
                                color: "#666666db",
                                fontStyle: "italic",
                                fontWeight: 300,
                            }}
                        >
                            Automatically set to match the fascia height of the adjoining Hip Joined area.
                        </div>
                    )}
                    {area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT &&
                        (pitch_matched_for_flat_hip || design_option?.pitch_range?.options) && (
                            <SegmentedButtonGroup
                                label={"Roof Pitch"}
                                tight
                                value={Math.abs(toNumber(ShapeParameters?.RoofPitch))}
                                items={
                                    pitch_matched_for_flat_hip
                                        ? [
                                              {
                                                  Key: ShapeParameters?.RoofPitch,
                                                  Display: Math.abs(toNumber(ShapeParameters?.RoofPitch)).toFixed(1),
                                              },
                                          ]
                                        : design_option?.pitch_range?.options.map((name) => ({
                                              Key: name,
                                              Display: name + "°",
                                              disabled:
                                                  toNumber(name) < min_design_pitch_allowed ||
                                                  toNumber(name) < min_pitch ||
                                                  toNumber(name) > max_design_pitch_allowed,
                                          }))
                                }
                                onChange={updateShapeData("RoofPitch")}
                                // helperText={
                                //     pitch_matched_for_flat_hip
                                //         ? "Automatically set to match the fascia height of the adjoining Hip Joined area."
                                //         : ""
                                // }
                            />
                        )}
                    {area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT &&
                        !pitch_matched_for_flat_hip &&
                        !design_option?.pitch_range?.options && (
                            <BSL_Slider
                                label={"Roof Pitch"}
                                helperText={
                                    "minimum = " +
                                    min_pitch +
                                    "° for " +
                                    area_design_specs[BASIC_SPECS_SECTIONS.ROOF_SHEETING]?.RoofGroupType
                                }
                                tight
                                value={Math.abs(toNumber(ShapeParameters?.RoofPitch))}
                                min={min_design_pitch_allowed}
                                max={max_design_pitch_allowed}
                                suffix={"°"}
                                marks={[
                                    {
                                        value: 1,
                                        label: "1°",
                                    },
                                    { value: 5 },
                                    { value: 10 },
                                    { value: 15 },
                                    { value: 20 },
                                    { value: 25 },
                                    {
                                        value: 30,
                                        label: "30°",
                                    },
                                ]}
                                step={1}
                                onChange={(e, val) => {
                                    if (
                                        area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT &&
                                        toNumber(ShapeParameters?.RoofPitch) < 0
                                    ) {
                                        val = -val;
                                    }
                                    updateShapeDataValue("RoofPitch", val);
                                }}
                            />
                        )}
                    {!window.LYSAGHT &&
                        (area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.GABLE_PORTAL ||
                            area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.PITCHED) && (
                            <SegmentedButtonGroup
                                label="Roof Pitch"
                                tight
                                value={toNumber(ShapeParameters?.RoofPitch)}
                                items={
                                    design_option?.pitch_range?.options
                                        ? design_option?.pitch_range?.options.map((pitch) => ({
                                              Key: pitch,
                                              Display: pitch + "°",
                                              disabled:
                                                  toNumber(pitch) < min_design_pitch_allowed ||
                                                  toNumber(pitch) < min_pitch ||
                                                  toNumber(pitch) > max_design_pitch_allowed,
                                          }))
                                        : window.LYSAGHT
                                        ? [{ Key: 22.5, Display: "22.5°" }]
                                        : [
                                              { Key: 15, Display: "15°" },
                                              { Key: 20, Display: "20°" },
                                              { Key: 25, Display: "25°" },
                                              { Key: 30, Display: "30°" },
                                          ]
                                }
                                onChange={updateShapeData("RoofPitch")}
                            />
                        )}
                </BSL_Common.SectionRow>
                {area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT && (
                    <BSL_CheckBox
                        tight
                        checked={ShapeParameters.RoofPitch < 0}
                        disabled={ShapeParameters.DesignSubType !== "Type 4"}
                        label="Reverse Fall"
                        onChange={(checked) => {
                            updateShapeDataValue(
                                "RoofPitch",
                                checked
                                    ? -Math.abs(toNumber(ShapeParameters.RoofPitch))
                                    : Math.abs(toNumber(ShapeParameters.RoofPitch))
                            );
                        }}
                        style={{
                            marginTop: "-12px",
                        }}
                    />
                )}
            </BSL_Common.SectionContainer>

            {area_design_specs.SHAPE.DesignType === CONFIG.DESIGN_TYPES.FLAT && (
                <>
                    <BSL_Common.SectionHeader>Cutouts</BSL_Common.SectionHeader>
                    <BSL_Common.SectionContainer>
                        <BSL_Common.SectionRow style={{ justifyContent: "center" }}>
                            <BSL_Button
                                onClick={() => {
                                    setOpenCutouts(!open_cutouts);
                                }}
                            >
                                ADD / MODIFY CUTOUTS
                            </BSL_Button>
                        </BSL_Common.SectionRow>
                        <div className={classes.cutoutSummary}>{getCutoutSummary(area_design_specs.SHAPE.CUTOUTS)}</div>
                    </BSL_Common.SectionContainer>
                </>
            )}

            <Drawer
                anchor="right"
                className="noClickEvents"
                PaperProps={{ classes: { root: classes.paper_root } }}
                BackdropProps={{ classes: { root: "hidden" } }}
                open={open_cutouts}
                onClose={() => {
                    setOpenCutouts(!open_cutouts);
                }}
            >
                <div style={{ height: "100%", pointerEvents: "all" }}>
                    <SpecShapeCutoutTool
                        areaIndex={areaIndex}
                        onClose={() => {
                            setOpenCutouts(!open_cutouts);
                        }}
                        job={props.job}
                    />
                </div>
            </Drawer>
        </div>
    );
}

const getCutoutSummary = (CUTOUTS) => {
    const areas = ["BackLeft", "BackMid", "BackRight", "FrontLeft", "FrontRight"];
    let output = [];
    for (let area of areas) {
        let this_cutout = CUTOUTS[area + "-CutoutType"];
        if (this_cutout && this_cutout !== "None") {
            output.push(
                <>
                    {area + ": " + this_cutout}
                    <br />
                </>
            );
        }
    }
    return output;
};
